import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Faqs from './settings/Faqs'
import Support from './hilfe/Support'
import Language from './settings/Language'
import { useThemeColor } from '../hooks/useThemeColor'
import { useTranslation } from '../i18n/LanguageContext'

const Hilfe = () => {
  const [selectedTab, setSelectedTab] = useState('faqs');
  const { aispaceColor } = useThemeColor();
  const { t } = useTranslation();
  const { data: userData } = useSelector((state) => state.admin);
  const showLanguageTab = userData?.user_role === 'normal' || userData?.user_role === 'No License';

  useEffect(() => {
    // Block scroll for hilfe page
    document.body.classList.add('block-scroll');
    return () => {
      document.body.classList.remove('block-scroll');
    };
  }, []);

  return (
    <div className="h-screen bg-white overflow-hidden flex flex-col">
      <header className="px-10 h-[80px] flex items-center flex-shrink-0">
        <h1 className="text-[22px] font-bold text-[#111827]">{t('helpCenter.title')}</h1>
      </header>

      {/* Sticky Tabs — stays in place while content below scrolls */}
      <div className="flex-shrink-0 bg-white px-10 border-b border-[#E5E7EB]">
        {/* Tabs */}
        <div className="flex items-center gap-6">
          <button
            onClick={() => setSelectedTab('faqs')}
            className={`pb-3 text-[14px] font-medium transition-colors relative ${
              selectedTab !== 'faqs' ? 'text-[#6B7280] hover:text-[#374151]' : ''
            }`}
            style={selectedTab === 'faqs' ? { color: aispaceColor } : {}}
          >
            {t('helpCenter.tabFaqs')}
            {selectedTab === 'faqs' && (
              <div
                className="absolute -bottom-px left-0 right-0 h-[2px] rounded-full"
                style={{ backgroundColor: aispaceColor }}
              />
            )}
          </button>
          <button
            onClick={() => setSelectedTab('support')}
            className={`pb-3 text-[14px] font-medium transition-colors relative ${
              selectedTab !== 'support' ? 'text-[#6B7280] hover:text-[#374151]' : ''
            }`}
            style={selectedTab === 'support' ? { color: aispaceColor } : {}}
          >
            {t('helpCenter.tabSupport')}
            {selectedTab === 'support' && (
              <div
                className="absolute -bottom-px left-0 right-0 h-[2px] rounded-full"
                style={{ backgroundColor: aispaceColor }}
              />
            )}
          </button>
          {showLanguageTab && (
            <button
              onClick={() => setSelectedTab('language')}
              className={`pb-3 text-[14px] font-medium transition-colors relative ${
                selectedTab !== 'language' ? 'text-[#6B7280] hover:text-[#374151]' : ''
              }`}
              style={selectedTab === 'language' ? { color: aispaceColor } : {}}
            >
              {t('settings.tabLanguage')}
              {selectedTab === 'language' && (
                <div
                  className="absolute -bottom-px left-0 right-0 h-[2px] rounded-full"
                  style={{ backgroundColor: aispaceColor }}
                />
              )}
            </button>
          )}
        </div>
      </div>

      {/* Scrollable Tab Content */}
      <div className="flex-1 overflow-y-auto px-10 py-8">
        {selectedTab === 'faqs' && <Faqs />}
        {selectedTab === 'support' && <Support />}
        {selectedTab === 'language' && showLanguageTab && <Language />}
      </div>
    </div>
  )
}

export default Hilfe
